import { useQuery } from "react-query";
import axiosClient from "./../config/axiosClient";
import { downloadFile } from "../utils/file";

const useOffersList = ({company_id, page=1, per_page=10}) => {
  return useQuery(
    ['offers-list', company_id, page], 
    () => {
      return axiosClient
        .get(`/issuer/companies/${company_id}/offers`, {params: {page, per_page}})
    }, {
      keepPreviousData: true,
    }
  );
}

const useOffer = ({offer_id}) => {
  return useQuery(
    ["offer", offer_id], 
    () => {
      return axiosClient
        .get(`/issuer/offers/${offer_id}`)
    }
  );
}

const useOfferPitch = ({offer_id}) => {
  return useQuery(
    ["offer-pitch", offer_id],
    () => {
      return axiosClient
        .get(`/offers/${offer_id}/pitch`)
    }, {
      initialData: {},
    }
  );
}

const udpateOfferPitch = ({pitchable_id, values}) => {
  return axiosClient.put(`/offers/${pitchable_id}/pitch`, values)
}

const deletePitchSection = ({section_id, type}) => {
  return axiosClient.delete(`/pitch_sections/${section_id}`, {data: {type: type}})
}

const useOfferInvestorsList = ({offer_id}) => {
  return useQuery(
    ["offer-investors-list", offer_id],
    () => {
      return axiosClient
        .get(`/offers/${offer_id}/investors.json?type=all`)
    }
  )
}

const useExportOfferInvestorsList = ({offer_id, type="all", opts={enabled: false}}) => {
  return useQuery(
    ['offer', offer_id, 'export-investors', type],
    () => {
      return axiosClient
        .get(`/offers/${offer_id}/investors.csv`, {params: {type}})
    },
    {
      ...opts,
      onSuccess: (data) => {
        downloadFile(data, `offer-${offer_id}-investors.csv`)
      }
    }
  );
}


export {
  useOffersList,
  useOffer,
  useOfferPitch,
  udpateOfferPitch,
  deletePitchSection,
  useOfferInvestorsList,
  useExportOfferInvestorsList,
}
